import {
  PROJECT_MAP_CARD_HEIGHT,
  PROJECT_MAP_CARD_GAP,
} from '../lists/project-list.constants';

/** Fit 450–600 px cards into 60% of the viewport; retain the minimum on narrow screens. */
export const getProjectMapLayout = (
  viewportWidth: number,
  viewportHeight: number,
  projectCount: number,
) => {
  const maxWidth = viewportWidth * 0.6;
  const sideGutters = 16;
  const availableColumns = Math.max(
    1,
    Math.floor(
      (maxWidth - sideGutters + PROJECT_MAP_CARD_GAP) /
        (450 + PROJECT_MAP_CARD_GAP),
    ),
  );
  const rows = Math.max(
    1,
    Math.floor(
      viewportHeight / (PROJECT_MAP_CARD_HEIGHT + PROJECT_MAP_CARD_GAP),
    ),
  );
  const columns = Math.max(
    1,
    Math.min(availableColumns, Math.floor(projectCount / rows)),
  );
  const stretchedCardWidth =
    (maxWidth - sideGutters - (availableColumns - 1) * PROJECT_MAP_CARD_GAP) /
    availableColumns;
  const cardWidth = Math.max(450, Math.min(stretchedCardWidth, 600));
  return {
    columns,
    width:
      cardWidth * columns + (columns - 1) * PROJECT_MAP_CARD_GAP + sideGutters,
  };
};
